import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";


import website_logo from "../images/website_Logo.png";
import Logo from "./video/Mariniz Logo Gold.png";
import axios from "axios";
import config from "../function/config";
 
export default function NewFooter() {
const [user,setUser] = useState(null)
const token = localStorage.getItem('token')
 
useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewusers`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        console.log("API response:", res2.data);
        if (res2.data.status === 200) {
          console.log(res2);
          setUser(res2.data.data);
        } else {
          console.log(res2);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [ token]);
  const resolveRoute = (user, guestPath, userPath, adminPath) => {
  if (user?.is_superuser) return adminPath;   // admin
  if (user) return userPath;                  // logged-in normal user
  return guestPath;                           // not logged in
};

  return (
    <div>
       <footer className=" bg-[#2e5775] px-[110px] xm:px-3 py-8 text-white sm:px-8">
          <div className="flex justify-between xm:flex-wrap xm:gap-8  md:flex-row ">
            {/* heading */}
            <div className="flex flex-col">
              
               
                 <div className="w-[200px]"> <img src={Logo} className="" alt="" /></div>
                
             
              <div>
                <p className="mt-2 max-w-xs text-xs text-white">
                  A modern digital marketplace for buying, selling and chartering
                  commercial vessels worldwide.
                </p>
              </div>
             
            </div>

            {/* Social Links */}
              <div>
                                     
                                  <div className="flex flex-col gap-5 items-center px-3 ">
                                    <Link className="flex items-center gap-2" to={'https://www.facebook.com/groups/2708905909353211'}>
                                      <i className="fa-brands hover:scale-125 duration-200 hover:text-blue-400 fa-facebook text-2xl text-blue-600"></i> <span className="text-xs">facebook</span>
                                    </Link>
                                    <Link className="flex items-center gap-2" to={'https://www.instagram.com/data.marine/?hl=en'}>
                                      <i className="fa-brands fa-instagram hover:scale-125 duration-200 hover:text-pink-400 text-2xl text-pink-500"></i> <span className="text-xs">Instagram</span>
                                    </Link>
                                    <Link
                                      target="_blank"
                                      className="flex items-center gap-2"
                                      to={
                                        'https://wa.me/971503505898?text=Hello%20Happy%20Marine%20Shipping,%20I%20would%20like%20to%20inquire%20about%20your%20services.'
                                      }
                                    >
                                      <i className="fa-brands fa-whatsapp hover:scale-125 duration-200 hover:text-green-400 text-2xl text-green-500"></i> <span className="text-xs">whatsapp</span>
                                    </Link>
                                  </div>
                      
                                  </div>
            {/* Links */}
            {/* Links */}
<div className="flex flex-col gap-4 text-xs text-white">
  {/* Ships for Sale */}
  <Link
    to={resolveRoute(
      user,
      "/ship-for-sale",        // guest
      "/userShipForSale",    // normal user
      "/adminShipForSale"    // superuser
    )}
    className="hover:text-white"
  >
    Ships for Sale
  </Link>

 

  {/* Open Ships */}
  <Link
    to={'/map/ship-chartering'}
    className="hover:text-white"
  >
    Open Ships
  </Link>

  {/* Open Cargo */}
  <Link
   to={'/map/open-cargo'}
    className="hover:text-white"
  >
    Open Cargo
  </Link>

  {/* Contact */}
  <Link
    to={resolveRoute(
      user,
      "/contact",            // guest
      "/userContact",        // normal user
      "/adminContact"        // superuser
    )}
    className="hover:text-white"
  >
    Contact
  </Link>
</div>

            {/* social Links */}
            <div>
              <h3 className="mb-4 text-sm font-semibold">Blogs</h3>
            </div>
          </div>
          <div className="mt-6 border-t text-center border-slate-800 pt-4 text-xs text-white">
            © {new Date().getFullYear()} Mariniz.com · All rights reserved.
          </div>
        </footer>
    </div>
  )
}
